import { useMemo } from "react";
import { Heart, Lock } from "lucide-react";

export default function LoveScreen() {
  const hearts = useMemo(
    () =>
      Array.from({ length: 18 }, (_, i) => ({
        id: i,
        left: Math.random() * 96,
        size: 14 + Math.random() * 26,
        delay: Math.random() * 9,
        duration: 7 + Math.random() * 8,
        opacity: 0.25 + Math.random() * 0.45,
      })),
    []
  );

  const logout = () => {
    ["kn_access_ok", "kn_access_role"].forEach((k) => sessionStorage.removeItem(k));
    ["kn_access_remember", "kn_access_role_remember"].forEach((k) => localStorage.removeItem(k));
    window.location.reload();
  };

  return (
    <div className="love-screen" data-testid="love-screen">
      <div className="love-hearts" aria-hidden="true">
        {hearts.map((h) => (
          <Heart
            key={h.id}
            className="heart-bubble"
            fill="currentColor"
            style={{
              left: `${h.left}%`,
              width: h.size,
              height: h.size,
              opacity: h.opacity,
              animationDelay: `${h.delay}s`,
              animationDuration: `${h.duration}s`,
            }}
          />
        ))}
      </div>

      <div className="love-card">
        <img
          className="love-bunny"
          data-testid="love-bunny-image"
          src="https://static.prod-images.emergentagent.com/jobs/fe9a795a-9b27-4bfd-9166-eea07adda0cf/images/ad219c60eaaadc2c3bbd50ecaa7a7df41ad52c1ebb13ff3200b922d2e309fabc.jpeg"
          alt="Birbirine sarılan tavşanlar"
        />
        <h1 data-testid="love-message">Sevgilin seni çok seviyor minik tavşanım</h1>
        <p>Sonsuza kadar birlikte</p>
      </div>

      <button className="love-logout" data-testid="love-logout" onClick={logout}>
        <Lock size={13} /> Şifre ekranına dön
      </button>
    </div>
  );
}
